module.exports = __webpack_public_path__ + "static/Slowly-Two-b072e6caf26315c3e9e0d1eff2ced30d.woff";